import { render, staticRenderFns } from "./VdAdminView.vue?vue&type=template&id=bcf90916&scoped=true"
import script from "./VdAdminView.vue?vue&type=script&lang=ts"
export * from "./VdAdminView.vue?vue&type=script&lang=ts"
import style0 from "./VdAdminView.vue?vue&type=style&index=0&id=bcf90916&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf90916",
  null
  
)

export default component.exports